import "esbuild-css-modules-plugin-ns-css:src/styles/debug.module.css";

export default {
  "app": "debug-module__app_V9dfrW__010",
  "content": "debug-module__content_V9dfrW__010",
  "sideBar": "debug-module__sideBar_V9dfrW__010",
  "sideBarBackground": "debug-module__sideBarBackground_V9dfrW__010",
  "sideBarContent": "debug-module__sideBarContent_V9dfrW__010",
  "sideBarItem": "debug-module__sideBarItem_V9dfrW__010",
  "sideBarList": "debug-module__sideBarList_V9dfrW__010",
  "sideBarOpen": "debug-module__sideBarOpen_V9dfrW__010",
  "toggle": "debug-module__toggle_V9dfrW__010"
};
      